const primary = '#004987';
const secondary = '#7A9C49';
const text = '#15284B';
const grey = '#77777A';
const red = '#C62323';
const orange = '#C78D1F';
const white = '#FFFFFF';
const black = '#212121';
const transparent = 'transparent';
const beige = '#F8F6F2';
const background = '#F4F2EF';
const green = '#56C595';
const orangeRevamp = '#FEA100';
const ThemeColors = {
    primary,
    'primary.main': primary,
    'primary.dark': '#15284B',
    'primary.light': '#7FA3C0',
    'primary.hover': '#004987',
    'primary.background': '#135BD2',
    'primary.medium': '#135BD2',
    'primary.white': white,

    secondary,
    'secondary.main': secondary,
    'secondary.dark': '#6A813B',
    'secondary.light': '#9FB384',
    'secondary.hover': '#96b06e',

    'accent.green': green,
    'accent.greenDark': '#51BA92',
    'accent.purple': '#AE92EA',
    'accent.yellow': '#FFE755',
    'accent.orange': orangeRevamp,

    white,
    black,
    transparent,

    text,
    'text.main': text,
    'text.secondary': '#7A757A',
    'text.grey': grey,
    'text.light': '#ADADAD',
    'text.contrast': white,
    'text.disabled': '#ADADAD',

    grey,
    'grey.main': grey,
    'grey.light': '#F6F6F6',
    'grey.background': '#E4E2DF',
    'grey.dark': grey,

    red,
    error: red,
    'error.main': '#E7271C',
    'error.light': '#F2D2CD',

    orange,
    warning: orange,
    'warning.main': orange,
    'warning.light': '#c78d1f12',

    'success.main': green,
    'success.light': '#DBEBE1',
    beige,
    'beige.main': beige,
    'beige.light': '#D8E1E4',

    background: white,

    border: '#D1D1D1',
    'sheet.background': '#0A032F'
} as const;

const textRevamp = '#150764';
export const RevampedThemeColors = {
    primary,
    'primary.main': '#4188FF',
    'primary.dark': '#150764',
    'primary.light': '#E6EAF0',
    'primary.hover': '#004987',
    'primary.background': '#166BFA',
    'primary.medium': '#135BD2',
    'primary.white': white,

    secondary,
    'secondary.main': secondary,
    'secondary.dark': '#6A813B',
    'secondary.light': '#9FB384',
    'secondary.hover': '#96b06e',

    'accent.green': green,
    'accent.greenDark': '#51BA92',
    'accent.purple': '#AE92EA',
    'accent.yellow': '#FFE755',
    'accent.orange': orangeRevamp,
    white,
    black,
    transparent,

    text: textRevamp,
    'text.main': textRevamp,
    'text.secondary': '#7A757A',
    'text.grey': grey,
    'text.light': '#ADADAD',
    'text.contrast': white,
    'text.disabled': '#ADADAD',

    grey,
    'grey.main': '#DEDAE1',
    'grey.light': background,
    'grey.background': '#E4E2DF',
    'grey.dark': grey,

    red,
    error: red,
    'error.main': '#E7271C',
    'error.light': '#F2D2CD',

    orange: orangeRevamp,
    warning: orangeRevamp,
    'warning.main': orangeRevamp,
    'warning.light': '#F6E5C9',

    'success.main': green,
    'success.light': '#DBEBE1',
    beige,
    'beige.main': beige,
    'beige.light': '#D8E1E4',

    background,

    border: '#D1D1D1',
    'sheet.background': '#0A032F'
} as const;

export type ThemeColor = keyof typeof ThemeColors | keyof typeof RevampedThemeColors;

export type Color = ThemeColor | string;

export default ThemeColors;
